import {PinProtect} from '~/features/Auth/PinProtect';
import {PdfConsentSubmission} from '~/features/ParentPay';

export const PdfConsentSubmissionScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <PdfConsentSubmission />
      </PinProtect>
    </div>
  );
};
